<script setup lang="ts">
  const props = defineProps({
    statusMessage: {
      type: String,
      default: null
    }
  });
</script>

<template>
  <p v-if="props.statusMessage" class="jwx-spot-header__meta"><span class="jwx-page__meta-label">Status Message:</span> {{ props.statusMessage }}</p>
</template>